
export default {
  methods: {
    $notifySuccess(message, title = null, seconds = 4){
      this.$vs.notify({
        title: title,
        text: message,
        color: 'success',
        iconPack: 'feather',
        icon: 'icon-check',
        time: seconds * 1000,
        position: 'bottom-left',
      })
    },
    $notifyError(message){
      this.$vs.notify({
        text: message,
        color: 'danger',
        position: 'bottom-left',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    },
    $notifyWarning(message){
      this.$vs.notify({
        text: message,
        color: 'warning',
        iconPack: 'feather',
        icon: 'icon-alert-triangle',
        position: 'bottom-left'
      })
    },
  }
}

